// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"726":"73652b9e","2944":"df74cb28","4295":"84938a76","4393":"57652a0b","6598":"6139b19d","9707":"84938a76"}[chunkId] + ".chunk.css";
};